import { BrandColors, Colors } from "@/constants/theme";
import React from "react";
import { StyleSheet, useColorScheme, View } from "react-native";
import {
  HelperText,
  TextInput as PaperTextInput,
  TextInputProps,
} from "react-native-paper";

interface InputProps extends Omit<TextInputProps, "theme"> {
  label?: string;
  error?: boolean;
  errorText?: string;
}

export function Input({
  label,
  error = false,
  errorText,
  style,
  accessibilityLabel,
  ...props
}: InputProps) {
  const colorScheme = useColorScheme();
  const theme = Colors[colorScheme ?? "light"];
  const errorId = errorText ? `${label ?? "input"}-error` : undefined;

  return (
    <View>
      <PaperTextInput
        label={label}
        mode="outlined"
        error={error}
        style={[
          styles.input,
          { backgroundColor: theme.background, borderColor: theme.border },
          style,
        ]}
        outlineColor={theme.border}
        activeOutlineColor={BrandColors.primary}
        textColor={theme.text}
        placeholderTextColor={BrandColors.mediumGray}
        accessibilityLabel={accessibilityLabel ?? label}
        accessibilityHint={errorText}
        aria-invalid={error}
        aria-errormessage={errorId}
        outlineStyle={{
          borderRadius: 8,
        }}
        theme={{
          colors: {
            onSurfaceVariant: BrandColors.mediumGray,
          },
        }}
        {...props}
      />
      {errorText ? (
        <HelperText type="error" visible={!!errorText} accessibilityLiveRegion="polite">
          {errorText}
        </HelperText>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  input: {
    fontSize: 16,
  },
});
